query SubscriptionsList(
  $page: Int
  $rowsPerPage: Int
  $filter: SubscriptionsFilterInput
) {
  subscriptions(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      status
      startAt
      currentPeriodEnd
      billingCyclesComplete
      renewSubscription
      buyerEmail
      userId
      renewAttempts
      nextRenewAttemptAt
      pastDueSince
      renewErrorReason
      renewDeadlineAt
      product {
        id
        title
      }
      promocode {
        code
        title
      }
      revenue {
        value
        currency
      }
    }
  }
}
